import { Injectable, PLATFORM_ID, Inject } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { isPlatformBrowser } from "@angular/common";

import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { StoreService } from "./store.service";
import { GlobalContants } from "../constants/global.contants";


@Injectable({
    providedIn: 'root'
})

export class ApiService {
    
    isBrowser: boolean;
    userToken: string = '';
    city_id='';
    allowResources: any;
    CurrentLangCode: any = 'en';

    constructor(
        private http: HttpClient,
        private storeKey: StoreService,
        @Inject(PLATFORM_ID) private platformId: any,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    public storeInfo(){
        if(this.isBrowser){
            this.userToken = this.storeKey.get(GlobalContants.StoreKey.userToken) || environment.user_token;
            if(this.storeKey.get(GlobalContants.StoreKey.userInfo)){
                let user:any = this.storeKey.get(GlobalContants.StoreKey.userInfo);
                if(user && user?.place_access[0]){
                    this.city_id = user.place_access[0];
                }                
            }
           
        }
    }

    public get<T>(url: string, umsUrl: boolean = false): Observable<T> {
        let headers: any = {};
        headers['Content-Type']= 'application/json';

        headers = umsUrl ? {...headers, ...this.umsHeaders()} : {...headers, ...this.estAPIHeaders()};

        let options = { headers: new HttpHeaders(headers)};
        url = `${url}`;
        return this.http.get<T>(url, options);
    }

    public post<T>(url: string, payload: any = '',  umsUrl: boolean = false): Observable<T> {
        let headers: any = {};
        
        headers = umsUrl ? {...headers, ...this.umsHeaders()} : {...headers, ...this.estAPIHeaders()};

        let options = { headers: new HttpHeaders(headers)};
        url = `${url}`;
        return this.http.post<T>(url, payload, options);
    }
 
    public patch<T>(url: string, payload: any = '', umsUrl: boolean = false): Observable<T> {
        let headers: any = {};

        headers = umsUrl ? {...headers, ...this.umsHeaders()} : {...headers, ...this.estAPIHeaders()};

        let options = { headers: new HttpHeaders(headers)};
        url = `${url}`;
        return this.http.patch<T>(url, payload, options);
    }

    public delete<T>(url: string, umsUrl: boolean = false): Observable<T> {
        let headers: any = {};
        
        headers = umsUrl ? {...headers, ...this.umsHeaders()} : {...headers, ...this.estAPIHeaders()};

        let options = { headers: new HttpHeaders(headers)};
        url = `${url}`;
        return this.http.delete<T>(url, options);
    }

    public umsHeaders(): any{
        this.storeInfo();
        let headers: any = {};
        headers['User-Lang'] = this.CurrentLangCode;
        headers['app-id'] = environment.umsApp_id;
        headers['city-id']= this.city_id || "";
        headers['user-token'] = this.userToken ? this.userToken : environment.user_token;
        return headers;
    }

    public estAPIHeaders(): any{
        this.storeInfo();
        let headers: any = {};
        headers['user-token'] = this.userToken;
        return headers;
    }

    getAVMRental(url:string, api_key:string, userToken:string, cityCode:string=''){
        let headers: any = {};
        headers['Content-Type']= 'application/json';
        headers['API-KEY'] = api_key;
        headers['USER-TOKEN'] = userToken;
        headers['CITY-CODE'] = cityCode;
        let options = { headers: new HttpHeaders(headers)};
        url = `${url}`;
        return this.http.get<any>(url, options); 
    }

    searchProperty(url: string, placeId: number) {
        let headers: any = {};
        headers['api-key'] = environment.markets_api_key;
        headers['user-token'] = this.userToken;
        headers['User-City'] = placeId;
        headers['User-Lang'] = 1;
        let options = { headers: new HttpHeaders(headers) };
        url = `${url}`;
        return this.http.get<any>(url, options);
    }

}